
export default superclass => class extends superclass {

    automationPaths = [];
    
    /**
     * Combines adjacent shapes into several automation lanes 
     */
    computeShapes() {
        // look thru the steps and compute

        // sort shapes by x
        let steps = [... this.steps].sort(
            (a,b) => a.x===b.x ? b.y - a.y : a.x - b.x);

        let stepsToProcess = [... steps];

        let paths = [];
        while (stepsToProcess.length > 0) {
            let step = stepsToProcess.shift();
            let path = [step];
            let adjoining = this.findAdjoiningSteps(step);
            while (adjoining) {
                stepsToProcess = stepsToProcess.filter(
                    x => x !== adjoining);
                path.push(adjoining);
                adjoining = this.findAdjoiningSteps(adjoining);
            }
            paths.push(path);
        }

        // given these lists of steps calculate an actual path based
        // on the triangles
        let automationPaths = [];
        for (let path of paths) {
            let _path = [{x: path[0].x, y: path[0].y}];
            for (let i=0; i < path.length; i++ ){
                let pt = path[i];
                let _x = pt.x + pt.size;
                let _y = pt.y + pt.size;
                let nextPt = path[i+1];
                if (!nextPt) {
                    // no next pt so just use end pt 
                    _path = [... _path, {x: _x,y: _y}];
                } else if (_x === nextPt.x && _y === nextPt.y) {
                    // they share a pt
                    if (pt.orientation === nextPt.orientation ||
                       pt.orientation === 0 && nextPt.orientation === 1) {
                        _path = [... _path, {x: _x, y: _y}];
                    } else if (pt.orientation === 1 && nextPt.orientation === 0) {
                        _path = [... _path,
                                 {x: _x, y: pt.y},
                                 {x: _x, y: _y}];
                    }
                    
                } else if (_x === nextPt.x &&
                           _y === nextPt.y + nextPt.size) {
                    _path = [
                        ... _path,
                        {x: _x,y:_y},
                        {x: nextPt.x,y: nextPt.y}
                    ];
                } else {
                    // they dont share a pt so add both
                    // todo: depending on orientations add different
                    _path = [
                        ... _path,
                        {x: _x,y:_y},
                        {x: _x,y:10},
                        {x: nextPt.x,y:10},
                        {x: nextPt.x,y: nextPt.y}
                    ];
                }
            }
            automationPaths.push(_path);
        }
        this.automationPaths = automationPaths;
    }

    findAdjoiningSteps(step) {
        let {x,y, size} = step;

        // end point
        let _x = x + size;
        let _y = y + size;

        if (!this.matrix[_x]) {
            return undefined;
        }
        for (let i=_x; i < 16; i++) {
            if (this.matrix[i][_y]) {
                return this.matrix[i][_y];
            }
            
            for (let j=_y; j < 10 ; j++) {
                if (this.matrix[i][j]) {
                    return this.matrix[i][j];
                }
            }
            for (let j=_y; j > 0; j--) {
                if (this.matrix[i][j]) {
                    return this.matrix[i][j];
                }
            }
        }
        return undefined;
    }
}
